'use es6';

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import text from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import withAddRedirectUrlModal from 'ContentComponents/cmv2/fields/withAddRedirectUrlModal';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UIButton from 'UIComponents/button/UIButton';
import UILink from 'UIComponents/link/UILink';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UIFormControl from 'UIComponents/form/UIFormControl';
import * as pagesSelectors from 'ContentData/selectors/pages';
import * as smartContentActions from 'ContentData/actions/TargetedContent';
import { RICH_TEXT, PAGE } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { compose } from 'redux';
import { FORM_RESPONSE_TYPE_OPTIONS } from 'ContentComponents/cmv2/constants';
import { ToolbarControlOptionsMap, ToolbarControlOptions } from 'tinymce-plugins/constants/toolbar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.${key}`;
const ENABLED_FEATURES = Object.keys(ToolbarControlOptionsMap).filter(option => {
  return ![ToolbarControlOptions.cta, ToolbarControlOptions.icon, ToolbarControlOptions.glyphs,
  // need to exclude this too in order to prevent icons
  ToolbarControlOptions.source_code, ToolbarControlOptions.snippet, ToolbarControlOptions.visual_blocks, ToolbarControlOptions.content_generation].includes(option);
});
function mapStateToProps(state) {
  return {
    pages: pagesSelectors.getPages(state)
  };
}
const mapDispatchToProps = {
  fetchSmartContent: smartContentActions.fetchSmartContent
};
class FormResponse extends PureComponent {
  constructor(props) {
    super(props);
    this.checkSmartContactPage = this.checkSmartContactPage.bind(this);
    this.onResponseTypeChange = this.onResponseTypeChange.bind(this);
    this.onMessageChange = this.onMessageChange.bind(this);
    this.onRedirectIdChange = this.onRedirectIdChange.bind(this);
    this.state = {
      hasSmartContactLookup: {}
    };
  }
  componentDidMount() {
    const {
      value: {
        redirect_id
      }
    } = this.props;
    if (redirect_id) this.checkSmartContactPage(redirect_id);
  }
  get fieldKey() {
    const {
      fieldKey
    } = this.props;
    return fieldKey && fieldKey.join('.');
  }
  checkSmartContactPage(pageId) {
    const hasSmartContactPage = this.state.hasSmartContactLookup[pageId];
    if (hasSmartContactPage === undefined) {
      this.props.fetchSmartContent(pageId).then(response => {
        const pageSmartContactInfo = {
          hasSmartContactRule: false
        };
        if (response && Array.isArray(response)) {
          response.forEach(item => {
            item.criteria.forEach(criterion => {
              pageSmartContactInfo.contactList = pageSmartContactInfo.contactList || criterion.type === 'CONTACT_LIST';
              pageSmartContactInfo.contactLifecycle = pageSmartContactInfo.contactLifecycle || criterion.type === 'CONTACT_LIFECYCLE';
            });
          });
        }
        pageSmartContactInfo.hasSmartContactRule = pageSmartContactInfo.contactList || pageSmartContactInfo.contactLifecycle;
        this.setState({
          hasSmartContactLookup: Object.assign({}, this.state.hasSmartContactLookup, {
            [pageId]: pageSmartContactInfo
          })
        });
      }).catch(err => {
        setTimeout(() => {
          throw err;
        });
      });
    }
  }
  onResponseTypeChange(e) {
    this.props.onFieldChange(Object.assign({}, this.props.value, {
      response_type: e.target.value
    }));
  }
  onMessageChange(message) {
    this.props.onFieldChange(Object.assign({}, this.props.value, {
      message
    }));
  }
  onRedirectIdChange(e) {
    this.checkSmartContactPage(e.target.value);
    this.props.onFieldChange(Object.assign({}, this.props.value, {
      redirect_id: e.target.value,
      redirect_url: null
    }));
  }
  renderResponseTypes() {
    const {
      value: {
        response_type: responseType
      },
      readOnly,
      hasFormsWriteAccess
    } = this.props;
    const readOnlyProp = readOnly || !hasFormsWriteAccess;
    const responseTypeOptions = Object.keys(FORM_RESPONSE_TYPE_OPTIONS).map(_responseTypeKey => {
      const _responseType = FORM_RESPONSE_TYPE_OPTIONS[_responseTypeKey];
      return /*#__PURE__*/_jsx(UIRadioInput, {
        checked: responseType === _responseType,
        "data-selenium": `${this.fieldKey}:responseTypeInput:${_responseType}`,
        name: `${this.fieldKey}.${_responseTypeKey}`,
        onChange: this.onResponseTypeChange,
        readOnly: readOnlyProp,
        size: "small",
        value: _responseType,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(`responseType.options.${_responseType}`)
        })
      }, _responseTypeKey);
    });
    return /*#__PURE__*/_jsx(UIFormControl, {
      className: "m-top-4",
      label: text(i18nKey('responseType.label')),
      children: /*#__PURE__*/_jsx("div", {
        children: responseTypeOptions
      })
    });
  }
  renderRedirectOption({
    children
  }) {
    return /*#__PURE__*/_jsx(UITruncateString, {
      children: children
    });
  }
  renderResponse() {
    const {
      AddRedirectUrlModal,
      componentsByType,
      fieldKey,
      hasFormsWriteAccess,
      modulePath,
      openAddRedirectUrlModal,
      pages,
      readOnly,
      useOnDark,
      value: {
        message,
        redirect_id: redirectId,
        redirect_url: redirectUrl,
        response_type: responseType
      }
    } = this.props;
    const hasSmartContactRuleObj = this.state.hasSmartContactLookup[redirectId];
    const RichText = componentsByType[RICH_TEXT];
    const PageSelect = componentsByType[PAGE];
    const readOnlyProp = readOnly || !hasFormsWriteAccess;
    if (responseType === FORM_RESPONSE_TYPE_OPTIONS.INLINE) {
      return /*#__PURE__*/_jsx(UIFormControl, {
        "data-selenium": `${this.fieldKey}:response:inlineRichTextEditor`,
        label: text(i18nKey('message.label')),
        children: /*#__PURE__*/_jsx(RichText, {
          enabled_features: ENABLED_FEATURES,
          fieldKey: fieldKey,
          modulePath: modulePath,
          onFieldChange: this.onMessageChange,
          readOnly: readOnlyProp,
          value: message
        })
      });
    }
    let redirectPageUrl = null;
    if (pages[redirectId]) {
      redirectPageUrl = pages[redirectId].absoluteUrl;
    }
    const extraOptions = redirectUrl ? [{
      text: redirectUrl,
      value: redirectUrl
    }] : [];
    const redirectUrlLink = /*#__PURE__*/_jsxs(UIButton, {
      size: "small",
      use: "link",
      disabled: readOnlyProp,
      onClick: openAddRedirectUrlModal,
      children: [/*#__PURE__*/_jsx(UIIcon, {
        className: "m-right-1",
        name: "add"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('redirect.addRedirectUrl')
      })]
    });
    const previewUrl = redirectId ? redirectPageUrl : redirectUrl;
    const previewLink = previewUrl && /*#__PURE__*/_jsx("div", {
      className: "m-top-2",
      children: /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: previewUrl,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('redirect.viewLink')
        })
      })
    });
    return /*#__PURE__*/_jsx(UIFormControl, {
      "data-selenium": `${this.fieldKey}:response:redirectPageSelect`,
      label: text(i18nKey('redirect.label')),
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(PageSelect, {
          readOnly: readOnlyProp,
          onChange: this.onRedirectIdChange,
          extraOptions: extraOptions,
          dropdownFooter: redirectUrlLink,
          value: redirectUrl || redirectId || '',
          placeholder: text(i18nKey('redirect.selectPlaceholder')),
          required: false,
          useOnDark: useOnDark
        }), previewLink, AddRedirectUrlModal, hasSmartContactRuleObj && hasSmartContactRuleObj.hasSmartContactRule && /*#__PURE__*/_jsx(UIAlert, {
          className: "m-y-3",
          type: "warning",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: i18nKey('redirect.smartContentWarning.message'),
            options: {
              smartContentWarningPartA: /*#__PURE__*/_jsx(FormattedMessage, {
                message: hasSmartContactRuleObj.contactList && hasSmartContactRuleObj.contactLifecycle ? i18nKey('redirect.smartContentWarning.listMembershipAndLifecycleStage') : hasSmartContactRuleObj.contactList && i18nKey('redirect.smartContentWarning.listMembership') || hasSmartContactRuleObj.contactLifecycle && i18nKey('redirect.smartContentWarning.lifecycleStage')
              }),
              smartContentWarningLink: /*#__PURE__*/_jsx(UILink, {
                external: true,
                use: "on-bright",
                href: "https://knowledge.hubspot.com/website-pages/smart-content-frequently-asked-questions#thank-you",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: i18nKey('redirect.smartContentWarning.link')
                })
              })
            }
          })
        })]
      })
    });
  }
  render() {
    return /*#__PURE__*/_jsxs("div", {
      children: [this.renderResponseTypes(), this.renderResponse()]
    });
  }
}
FormResponse.propTypes = {
  AddRedirectUrlModal: PropTypes.node,
  componentsByType: PropTypes.object.isRequired,
  fetchSmartContent: PropTypes.func.isRequired,
  fieldKey: PropTypes.array,
  hasFormsWriteAccess: PropTypes.bool,
  modulePath: PropTypes.string,
  onFieldChange: PropTypes.func.isRequired,
  openAddRedirectUrlModal: PropTypes.func.isRequired,
  pages: PropTypes.object,
  readOnly: PropTypes.bool,
  useOnDark: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
};
FormResponse.defaultProps = {
  fieldKey: [],
  options: [],
  pages: {},
  readOnly: false,
  scopes: [],
  value: {
    response_type: 'inline',
    message: ''
  }
};
export default compose(connect(mapStateToProps, mapDispatchToProps), withAddRedirectUrlModal)(FormResponse);